import { AccountPaymentMethodsComponent } from './../account-payment-methods/account-payment-methods.component';
import { RegLayoutPopupComponent } from './../reg-layout-popup/reg-layout-popup.component';
import { RegIntroPopupComponent } from './../reg-intro-popup/reg-intro-popup.component';
import { RegWelcomePopupComponent } from './../reg-welcome-popup/reg-welcome-popup.component';
import { StripeSuccessPopupComponent } from './../stripe-success-popup/stripe-success-popup.component';
import { GuestModePopupComponent } from './../guest-mode-popup/guest-mode-popup.component';
import { ComponentUtilities } from './../shared/component.utilities';
import { IntercomModule } from 'ng-intercom';
import { MobileMenuComponent } from './../mobile-menu/mobile-menu.component';
import { HeaderComponent } from './../header/header.component';
import { AccountShareComponent } from '../account-share/account-share.component';
import { AngularFireDatabase } from 'angularfire2/database';
import { UploadService } from './../uploads/shared/upload.service';
import { UploadFormComponent } from './../uploads/upload-form/upload-form.component';
import { AngularFirestoreModule } from 'angularfire2/firestore';

import { CommonModule } from '@angular/common';
// import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';  // A
// import {Router, ActivatedRoute, RouterModule }from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// router
/* ROUTINGS */
import { appRoutes } from '../app.routing';
// components
import { RegistryComponent } from '../registry/registry.component';
import { GiftComponent } from '../gift/gift.component';
import { GiftDescriptionComponent } from '../gift-description/gift-description.component';
import { GiftWishComponent } from '../gift-wish/gift-wish.component';
import { GiftDetailComponent } from '../gift-detail/gift-detail.component';
import { GiftPaymentComponent } from '../gift-payment/gift-payment.component';
import { HeaderBackgroundPopupComponent } from '../header-background-popup/header-background-popup.component';



import { NgDatepickerModule } from 'ng2-datepicker';
// services
import { CartService } from '../cart/cart.service';
import { HttpService } from '../shared/http.service';
import { UnsplashImageService } from '../unsplash/unsplash.service';
import { SettingsService } from '../settings/settings.service';
import { PaymentService } from '../payment/payment.service';
import { UserService } from '../user/user.service';
// models

import { AngularFittextModule } from 'angular-fittext';
import { ConfigurationService } from '../shared/configuration.service';

import { CustomValidatorsService } from '../shared/validators.service';
import { CreateGiftComponent } from '../create-gift/create-gift.component';
import { TrackComponent } from '../track/track.component';
import { TrackDetailComponent } from '../track-detail/track-detail.component';

import { AccountPersonalComponent } from '../account-personal/account-personal.component';
import { AccountNotificationsComponent } from '../account-notifications/account-notifications.component';
import { AccountPaymentComponent } from '../account-payment/account-payment.component';
import { AccountFeesComponent } from '../account-fees/account-fees.component';
import { GetStartedComponent } from '../get-started/get-started.component';
// import { UiSwitchModule } from 'ngx-ui-switch';
import { AuthGuard } from '../guards/auth.guard';
import { PersonalComponent } from '../personal/personal.component';
import { PersonalTempCreateModeComponent } from '../personal-temp-createmode/personal-temp-createmode.component';

// import { HeaderComponent } from '../header/header.component';

import { RegistryPopupComponent } from '../registry-popup/registry-popup.component';
import { environment } from '../../environments/environment';
import { Registry404Component } from '../registry404/registry404.component';

import { AnalyticsService } from '../analytics/analytics.service';
import { AngularFireModule } from 'angularfire2';
import { ToastComponent } from '../toast/toast.component';
import { BannerComponent } from '../banner/banner.component';
import { WelcomePopupComponent } from '../welcome-popup/welcome-popup.component';


import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { DraggableModule } from '../dragndrop/draggable.module';
import { PipeModule } from '../pipes/pipe.moudle';
import { LanguageLocalePipe } from '../pipes/language-locale.pipe';
import { HitchdPaymentPageComponent } from '../hitchd-payment-page/hitchd-payment-page.component';
import { RegFontPopupComponent } from '../reg-font-popup/reg-font-popup.component';
import { ContributionSuccessPopupComponent } from '../contribution-success-popup/contribution-success-popup.component';
import { HitchdCardsPaymentPageComponent } from '../hitchd--cards-payment-page/hitchd-cards-payment-page.component';
import { ThankYouComponent } from '../thank-you/thank-you.component';
import { AccountDeleteComponent } from '../account-delete/account-delete.component';
import { AccountReferralComponent } from '../account-referral/account-referral.component';
import { TemplateComponent } from '../templates/templates.component';
import { GuestCardsComponent } from '../guest-cards/guest-cards.component';
import { RegColoursPopupComponent } from '../reg-colours-popup/reg-colours-popup.component';
import { RegShapePopupComponent } from '../reg-shape-popup/reg-shape-popup.component';
import { RegImageCropPopupComponent } from '../reg-image-crop/reg-image-crop-popup.component';
import { TranslatorService } from '../translator/translator.service';
import { RegSetupPopupComponent } from '../reg-setup/reg-setup-popup.component';
import { LazyLoadDirective } from '../video/lazyload.directive';
import { MiniThanksComponent } from '../mini-thanks/mini-thanks.component';
import { WebsiteBuilderComponent } from '../website-builder/website-builder.component';
import { WebsiteComponent } from '../website/website.component';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import { GuestListComponent } from '../guest-list/guest-list.component';
import { GuestStateStore } from '../guest-list/guest.state.store';
import { WebsiteTemplate1Component } from '../website-template1/website-template1.component';
import { WebsiteTemplate2Component } from '../website-template2/website-template2.component';
import { OverviewComponent } from '../overview/overview.component';
import { OverviewSettingsComponent } from '../overview-settings/overview-settings.component';
import { SettingsStateStore } from '../settings/settings.state.store';
import { RegistryStateStore } from './registry.state.store';
import { WebsiteTemplateLottieComponent } from '../website-template-lottie/website-template-lottie.component';
import { WebsiteTemplateCelineComponent } from '../website-template-celine/website-template-celine.component';
import { RsvpComponent } from '../rsvp/rsvp.component';
import { MegaMenuComponent } from '../mega-menu/mega-menu.component';
import { TranslationSettingsComponent } from '../translation-settings/translation-settings.component';
import { ContenteditableModelDirective } from '../guest-list/content-editable-modal';
import { VisibilitySettingsComponent } from '../visibility-settings/visibility-settings.component';
import { LandingComponent } from '../landing/landing.component';
import { LoadService } from '../mega-menu/load-service';
import { VeriffComponent } from '../veriff/veriff.component';
import { CreditCardSetupComponent } from '../credit-card-setup/credit-card-setup.component';
import { VeriffService } from '../veriff/veriff.service';
import { RouteReuseStrategy } from '@angular/router';
import { CustomReuseStrategy } from './custom-reuse-strategy';
import { QrCodeGeneratorComponent } from '../qr-code-generator/qr-code-generator.component';
import { PaymentPopupComponent } from '../payment-popup/payment-popup.component';
import { MerchantComponent } from '../merchant/merchant.component';
import { MerchantStateStore } from '../merchant/merchant.state.store';
import { GiftCreditCardComponent } from '../gift-creditcard/gift-creditcard.component';

@NgModule({
  declarations: [
    LazyLoadDirective,
    Registry404Component,
    GiftComponent,
    RegistryComponent,
    GiftDescriptionComponent,
    GiftWishComponent,
    GiftPaymentComponent,
    GiftDetailComponent,
    HeaderComponent,
    RegistryPopupComponent,
    ContenteditableModelDirective,
    MobileMenuComponent,
    // Auth
    // global

    TrackDetailComponent,
    CreateGiftComponent,

    TrackComponent,
    AccountPersonalComponent,
    AccountNotificationsComponent,
    AccountPaymentComponent,
    AccountFeesComponent,
    GetStartedComponent,
    PersonalComponent,
    PersonalTempCreateModeComponent,
    HeaderBackgroundPopupComponent,
    UploadFormComponent,
    BannerComponent,
    ToastComponent,
    WelcomePopupComponent,
    AccountShareComponent,
    GuestModePopupComponent,
    StripeSuccessPopupComponent,
    HitchdPaymentPageComponent,
    RegIntroPopupComponent,
    RegWelcomePopupComponent,
    RegFontPopupComponent,
    RegLayoutPopupComponent,
    ContributionSuccessPopupComponent,
    HitchdCardsPaymentPageComponent,
    ThankYouComponent,
    AccountPaymentMethodsComponent,
    AccountDeleteComponent,
    AccountReferralComponent,
    TemplateComponent,
    GuestCardsComponent,
    RegColoursPopupComponent,
    RegShapePopupComponent,
    RegImageCropPopupComponent,
    RegSetupPopupComponent,
    MiniThanksComponent,
    WebsiteBuilderComponent,
    WebsiteComponent,
    GuestListComponent,
    WebsiteTemplate1Component,
    WebsiteTemplate2Component,
    OverviewComponent,
    OverviewSettingsComponent,
    WebsiteTemplateLottieComponent,
    WebsiteTemplateCelineComponent,
    RsvpComponent,
    MegaMenuComponent,
    TranslationSettingsComponent,
    VisibilitySettingsComponent,
    LandingComponent,
    VeriffComponent,
    CreditCardSetupComponent,
    PaymentPopupComponent,
    LandingComponent,
    QrCodeGeneratorComponent,
    MerchantComponent,
    CreditCardSetupComponent,
    GiftCreditCardComponent,
    LanguageLocalePipe
  ],
  imports: [
    CommonModule,
    // BrowserModule,
    FormsModule,
    GooglePlaceModule,
    NgDatepickerModule,
    HttpModule,
    appRoutes,
    HttpClientModule,
    ReactiveFormsModule,
    AngularFirestoreModule,
    AngularFireModule.initializeApp(environment.firebase, 'my-app-name'), // imports firebase/app needed for everything
    DraggableModule,
    PipeModule,

    AngularFittextModule,

    IntercomModule.forRoot({

      appId: environment.intercomApiKey,
      updateOnRouterChange: true, // will automatically run `update` on router event changes. Default: `false`

    }), // imports firebase/app needed for everything
    // RegistrySharedModule,
    // AngularFireModule.initializeApp(environment.firebase, 'my-app-name'), // imports firebase/app needed for everything
    // AngularFirestoreModule, // imports firebase/firestore, only needed for database features
    // AngularFireAuthModule, // imports firebase/auth, only needed for auth features
  ],
  providers: [
    UploadService,
    CartService,
    TranslatorService,
    ConfigurationService,
    CustomValidatorsService,
    HttpService,
    AuthGuard,
    SettingsService,
    PaymentService,
    UserService,
    UnsplashImageService,
    AngularFireDatabase,
    AnalyticsService,
    ComponentUtilities,
    WebsiteStateStore,
    GuestStateStore,
    SettingsStateStore,
    RegistryStateStore,
    MerchantStateStore,
    LoadService,
    VeriffService,
    // CacheService
    // RegistryFirebaseService
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy }
  ],
  exports: [
    GiftCreditCardComponent
  ]
})
export class RegistryModule { }



// WEBPACK FOOTER //
// ./src/app/registry/registry.module.ts